import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { t } from "i18next";

function DiscountModal({ isOpen, toggle, discountRate, onDiscountRateChange, discountType = 'percent', onDiscountTypeChange }) {
  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={9999}
    >
      <ModalHeader>
        {t('sales.editDiscount')}
      </ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('sales.discountType')}: </Label>
          <Input type="select" value={discountType} onChange={e => onDiscountTypeChange(e.target.value)}>
            <option value="percent">{t('common.percentage')}</option>
            <option value="amount">{t('sales.fixedAmount')}</option>
          </Input>
        </FormGroup>
        <div>
          <Label>{t('sales.discount')}: </Label>
          <Input
            type="number"
            value={discountRate}
            onChange={e => onDiscountRateChange(parseFloat(e.target.value))}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <DefaultButton size="sm" color="secondary" onClick={toggle}>
          {t('common.cancel')}
        </DefaultButton>
        <DefaultButton size="sm" color="primary" onClick={() => {
          toggle();
        }}>{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default DiscountModal;